var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-bar",style:({
    background: _vm.bgColor
  })},[_c('div',{staticClass:"inner",style:({
      width: (_vm.width + "px")
    })},_vm._l((_vm.tabList),function(item){return _c('div',{key:item.value,staticClass:"tab-item",class:{current: item.value === _vm.value},on:{"click":function($event){return _vm.onTabClick(item)}}},[_vm._v("\n      "+_vm._s(item.label)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3985e4ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabBar/index.vue
// module id = null
// module chunks = 